import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

import Icon from '../Icon';

export const SearchIcon = styled(Icon)`
  position: absolute;
  top: 16px;
  left: 20px;
  width: 24px;

  ${media.M`
    left: 21px;
    right: 16px;
  `}
`;

export const GeolocIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 0;
  z-index: 2;
  cursor: pointer;
  width: 56px;
  height: 56px;
`;

export const GeolocIcon = styled(Icon)`
  &::after {
    content: '';
    position: absolute;
    top: 18px;
    left: 0;
    width: 1px;
    height: 20px;
    background-color: ${COLORS.NEUTRAL_STROKE};
  }

  ${media.M`
    right: 16px;
  `}
`;

export const Item = styled.li`
  padding: 8px 24px;

  cursor: pointer;
  font-size: 14px;
  line-height: 24px;

  & + & {
    /* Devrait être un gap sur le parent, mais on a pas la main */
    margin-top: 8px;
  }

  &:hover,
  &[aria-selected='true'] {
    color: ${COLORS.NEUTRAL_WHITE};
    background: ${COLORS.ACTION_DEFAULT};
  }

  &:not(:hover, [aria-selected='true']) .highlight {
    color: ${COLORS.ACTION_HOVER};
  }
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 17px;
  right: 7px;
  width: 40px;

  /* Le loader est plus petit  */
  [role='status'] {
    width: 25px;
    border-right-width: 4px;
  }

  ${media.M`
    right: 16px;
  `}
`;
